<script setup lang="ts">
import { computed } from 'vue';
import CopyButton from './CopyButton.vue';

const props = defineProps<{
  recommendation?: 'PASS' | 'REVIEW';
  summary?: string;
}>();

// 'PASS' has no confirmed literal headline anywhere seen so far — the only
// example available (the pre-v4 deployment this card restores) is a
// 'REVIEW' case. "Cleared" is a reasonable counterpart, not a grounded
// value; revisit if a real PASS example turns up.
const headline = computed(() => (props.recommendation === 'PASS' ? 'Cleared' : 'Needs review'));
</script>

<template>
  <section
    v-if="summary"
    class="rounded-xl border border-[var(--color-indigo-tint-border)] bg-[var(--color-indigo-tint-bg)] p-3.5"
    data-test="case-summary-card"
  >
    <div class="flex items-center justify-between gap-1.5">
      <div class="flex items-center gap-1.5">
        <span
          class="text-[11px] font-semibold tracking-wide text-[var(--color-indigo-tint-text)] uppercase"
        >
          Agent summary
        </span>
        <span class="text-[11px] text-[var(--color-indigo-tint-text)]">whole review</span>
      </div>
      <CopyButton :value="summary" label="agent summary" />
    </div>
    <h3 class="mt-1 text-[15px] font-bold text-[var(--color-indigo-tint-text)]">{{ headline }}</h3>
    <p
      class="mt-1.5 text-[13px] break-words whitespace-pre-wrap text-[var(--color-indigo-tint-text)]"
    >
      {{ summary }}
    </p>
  </section>
</template>
